const BASE = '/api';

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public code?: string,
  ) {
    super(message);
  }
}

export async function api<T = unknown>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    credentials: 'include',
  });

  if (res.status === 401) {
    sessionStorage.setItem('returnUrl', window.location.pathname);
    window.location.href = `https://hub.theonestack.com/login?returnUrl=${encodeURIComponent(window.location.href)}`;
    return new Promise<T>(() => {});
  }

  if (!res.ok) {
    let msg = res.statusText;
    let code: string | undefined;
    try {
      const body = await res.json();
      msg = body.error ?? body.message ?? msg;
      code = body.code;
    } catch {}
    throw new ApiError(res.status, msg, code);
  }

  if (res.status === 204) return undefined as T;
  return res.json();
}

export function get<T = unknown>(path: string) {
  return api<T>(path, { method: 'GET' });
}

export function post<T = unknown>(path: string, body?: unknown) {
  return api<T>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined });
}

export function put<T = unknown>(path: string, body?: unknown) {
  return api<T>(path, { method: 'PUT', body: body ? JSON.stringify(body) : undefined });
}

export function del<T = unknown>(path: string) {
  return api<T>(path, { method: 'DELETE' });
}
